import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container } from "../theme/common";
import { HeadingSection } from "../theme/components/HeadingSection";
import { COMMON, FONTSTYPO, SPACING } from "../theme/palette";
const WrapperStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "paddingBlock": SPACING.space2xl,
}));
const StatsSection = styled("div")(({ theme }) => ({
    "border": `1px solid ${theme.palette.grey["200"]}`,
    "borderRadius": FONTSTYPO.step0,
    "marginBlockStart": SPACING.spacel,
    "padding": SPACING.spacesL,
}));
const TagRowStyle = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "5px",
    "marginBlockStart": SPACING.spaces,
}));
const TagTitleStyle = styled("div")(({ theme }) => (Object.assign({}, theme.typography.h6)));
const TagStyle = styled("div")(({ theme }) => ({
    "background": theme.palette.secondary.light,
    "borderRadius": "4px",
    "color": theme.palette.secondary.main,
    "padding": "0.2em 0.6em 0.3em",
    "paddingInline": SPACING.spacem,
}));
const AwardsBadgeSection = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "16px",
    "img": {
        "blockSize": "auto",
        "inlineSize": "auto",
        "maxWidth": "128px",
    },
    "justifyContent": "center",
}));
const AwardsSection = styled("div")(() => (Object.assign(Object.assign({}, COMMON.grid), { "gridTemplateColumns": "repeat(auto-fit,minmax(16rem,1fr))" })));
const Divider = styled("hr")(({ theme }) => ({
    "backgroundColor": theme.palette.grey["200"],
    "blockSize": ".063em",
    "border": 0,
    "inlineSize": "100%",
    "marginBlockStart": SPACING.spaces,
    "marginBottom": SPACING.spacem,
}));
const HeadingStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { "color": theme.palette.primary.dark, "fontWeight": 350 })));
const SubHeadingStyle = styled(Typography)(({ theme }) => (Object.assign({}, theme.typography.body2)));
const HeadingSectionContainerStyle = styled("div")(() => ({
    "margin": " 0px auto",
    "maxInlineSize": " calc(77rem * .65)",
}));
const ProductBadgesStatsComponent = (props) => {
    const { heading, imagesItemsResourceChildCollection, statsItemsResourceChildCollection, subheading, topSectionHeading, topSectionUsers } = props;
    const [users, setUsers] = useState([]);
    const [isAwardSection, setIsAwardSection] = useState(false);
    const [isAwardTopSection, setIsAwardTopSection] = useState(false);
    useEffect(() => {
        if (isNotUndefinedOrNull(topSectionUsers)) {
            setUsers(topSectionUsers.split(","));
        }
    }, [topSectionUsers]);
    useEffect(() => {
        if ((isNotUndefinedOrNull(statsItemsResourceChildCollection) && statsItemsResourceChildCollection.length > 0) || isNotUndefinedOrNull(topSectionHeading)) {
            setIsAwardSection(true);
        }
    }, [topSectionHeading, statsItemsResourceChildCollection]);
    useEffect(() => {
        if ((isNotUndefinedOrNull(users) && users.length > 0) || isNotUndefinedOrNull(topSectionHeading)) {
            setIsAwardTopSection(true);
        }
    }, [topSectionHeading, users]);
    return (_jsx(ThemeProvider, { children: _jsx(WrapperStyle, { children: _jsxs(Container, { children: [_jsxs(HeadingSectionContainerStyle, { children: [_jsx(HeadingSection, { sectionHeading: heading, sectionSubHeading: subheading }), isNotUndefinedOrNull(imagesItemsResourceChildCollection) && imagesItemsResourceChildCollection.length > 0 ? _jsx(AwardsBadgeSection, { children: imagesItemsResourceChildCollection.map((image, index) => (_jsx("img", { alt: isNotUndefinedOrNull(image.imageAltText) ? image.imageAltText : "", src: image.image }, `Image${index}`))) }) : (_jsx(_Fragment, {}))] }), isAwardSection ? (_jsxs(StatsSection, { children: [isAwardTopSection ?
                                (_jsxs("div", { children: [_jsx(HeadingStyle, { children: topSectionHeading }), _jsx(TagRowStyle, { children: users.map((user) => (_jsx(TagStyle, { children: _jsx(TagTitleStyle, { children: user }) }, user))) })] })) : (_jsx(_Fragment, {})), isAwardTopSection && isNotUndefinedOrNull(statsItemsResourceChildCollection) && statsItemsResourceChildCollection.length > 0 ? _jsx(Divider, {}) : _jsx(_Fragment, {}), isNotUndefinedOrNull(statsItemsResourceChildCollection) && statsItemsResourceChildCollection.length > 0 ? _jsx(AwardsSection, { children: statsItemsResourceChildCollection.map((stat, index) => (_jsxs("div", { children: [_jsx(HeadingStyle, { children: stat.statHeading }), _jsx(SubHeadingStyle, { children: stat.statDes })] }, `stats${index}`))) }) : (_jsx(_Fragment, {}))] })) : (_jsx(_Fragment, {}))] }) }) }));
};
const productBadgesStats = (renderableData) => renderIdentifierGeneric(ProductBadgesStatsComponent, renderableData);
export { productBadgesStats };
